<template>
    <div>
        <div class="w3-container w3-center w3-margin-bottom w3-margin-top zero-right">
            <span class="table-count w3-col w-30pc w3-right w3-right-align flow-blue-color w3-medium w3-padding"
                  v-html="$t('showingAppointments', {number: sortedAndFilteredPatients.length})">
            </span>

            <div class="w3-left">
                <span v-for="status in getAllStatuses().reverse()"
                      v-if="!isStatusLeavingConsultation(status)"
                      class="w3-ripple flow-position-relative physician-patients-filter"
                      @click="selectStatusFilter(status)"
                      v-bind:class="selectedStatuses && selectedStatuses.includes(status) ? 'active' : ''">
                    <patient-status class="w3-xlarge w3-show-inline-block w3-margin-right cursor-pointer transform-animation"
                                    :status="status">
                    </patient-status>
                    <i class="active-check fa fa-check-circle flow-green-active-color w3-animate-opacity w3-large">
                    </i>
                </span>

                <span v-if="!isShared && room">
                    <span class="divider w3-xlarge flow-margin-left flow-margin-right">|</span>

                    <span class="w3-ripple flow-position-relative physician-patients-filter"
                          v-bind:class="showOnlyPrimaryGroup ? 'active' : ''"
                          @click="showOnlyPrimaryGroup = !showOnlyPrimaryGroup"
                          v-bind:title="$t('togglePrimaryGroupAppointments')">
                        <span class="flow-fa-icon w3-xlarge w3-show-inline-block w3-margin-right cursor-pointer transform-animation w3-border">
                            <i class="fa w3-xlarge" v-bind:class="showOnlyPrimaryGroup ? ' fa-bars' : ' fa-align-justify'"></i>
                        </span>

                        <i class="active-check fa fa-check-circle flow-green-active-color w3-animate-opacity w3-large"></i>
                    </span>
                </span>

            </div>
        </div>

        <div class="w3-col flow-card blue-top w3-padding">
            <table class="w3-table w3-bordered flow-table patients-table">
                <thead class="">
                    <th>{{ $t("time") }}</th>
                    <th>{{ $t("patient") }}</th>
                    <th>{{ $t("appointment") }}</th>
                    <th>{{ $t("tag") }}</th>
                    <th>{{ $t("location") }}</th>
                </thead>

                <tbody v-show="patients.length === 0">
                <tr>
                    <td colspan="8" class="w3-center flow-blue-color">
                        <b class="font-size-1pt25em">{{$t("noPatients")}}</b>
                    </td>
                </tr>
                </tbody>

                <tbody v-show="patients.length !== 0">
                <tr v-for="patient in sortedAndFilteredPatients">
                    <td>
                        {{ patient.appointmentTime }}
                    </td>

                    <td class="primary" @click="patientSelected(patient)">
                        <patient-status class="w3-show-inline-block w3-margin-right" :status="patient.status" :showMarker="true"></patient-status>
                        <span>{{patient.comment ? trim(patient.patientName) : patient.patientName}}</span>

                        <span v-if="loggedIn(patient) && !openPatientCard">
                                <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
                        </span>

                        <span v-if="patient.comment && !openPatientCard" class="w3-text-black font-weight-normal"> ({{ trim(patient.comment) }})</span>
                    </td>

                    <td>
                        <span v-if="patient.physician">{{ patient.physician.name }} - </span>
                        <span v-if="patient.consultationGroup" class="consultation-group">{{ patient.consultationGroup.displayName }} </span>
                        <span v-if="patient.consultationRoom" class="consultation-room flow-btn w3-round-medium font-weight-bold">
                        {{ patient.consultationRoom.displayName }}
                    </span>
                    </td>

                    <td>
                        {{ patient.ticket }}
                    </td>

                    <td>
                        <span v-if="patient.latestPosition">{{ patient.latestPosition.displayName }}</span>
                        <span v-else></span>
                    </td>

                    <td>
												<!-- For FlexiCall groups-->
                        <span v-if="!isStatusLeftConsultation(patient.status) && !isStatusInConsultation(patient.status) && !isStatusLeavingConsultation(patient.status)">
                            <appointment-priority
                                    :appointmentId = "patient.appointmentId"
                                    :patientId = "patient.patientId"
                                    :appointmentHasPriority = "patient.hasPriority">
                            </appointment-priority>

                            <span v-if="room && room.group.flexibleCall === true && patient.allowFlexibleCall">
                                <span v-if="flexiCallInProgress === false" @click="flexiCallAppointment(patient)" class="w3-padding-small cursor-pointer">
                                    <i class="fa fa-bullhorn w3-text-pink w3-large" :title="$t('callPatient')"></i>
                                </span>

                                <span v-else>
                                    <i class="fa fa-spinner w3-spin w3-large w3-opacity w3-disabled transform-animation"></i>
                                </span>
                            </span>

													<!-- For manual call & non-flexicall groups-->
	                        <span v-else-if="(room && room.group.autoCallPatients === false && room.group.flexibleCall === false && isStatusAtWaitingArea(patient.status))">
                                <span v-if="manualCallInProgress === false" @click="manuallyCallAppointment(patient)" class="w3-padding-small cursor-pointer">
                                    <i class="fa fa-bullhorn w3-text-pink w3-large" :title="$t('callPatient')"></i>
                                </span>

                                <span v-else>
                                    <i class="fa fa-spinner w3-spin w3-large w3-opacity w3-disabled transform-animation"></i>
                                </span>
                            </span>

                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PatientStatus from "../common/PatientStatus";
    import {EventBus} from "../../main";
    import AppointmentPriority from "../patient/AppointmentPriority";

    const frc = Vue.prototype.$frc;

    export default {
        name: "PatientsForCaller",
        components: {AppointmentPriority, PatientStatus},
        props: ['patients', 'onSelectCallback', 'isShared', 'openPatientCard', 'room', 'physician'],
        data: function () {
            return {
                sortedAndFilteredPatients: [],
                selectedStatuses: [],
                primaryGroup: undefined,
                showOnlyPrimaryGroup: true,
                manualCallInProgress: false,
                flexiCallInProgress: false
            }
        },
        mounted() {
            this.sortedAndFilteredPatients = this.patients;
            this.selectedStatuses = Vue.getOngoingStatusFilters();

            EventBus.$on("patientUpdated", this.updatePatientEntry);
            EventBus.$on("priorityUpdated", this.updatePatientEntryOnPriority);
            EventBus.$on("appointmentDeleted", this.updatePatientEntry);
            EventBus.$on("appointmentAdded", this.updatePatientEntryOrAdd);
            EventBus.$on("Relocated", this.updatePatientEntry);
        },
        beforeDestroy() {
            EventBus.$off("patientUpdated", this.updatePatientEntry);
            EventBus.$off("priorityUpdated", this.updatePatientEntryOnPriority);
            EventBus.$off("appointmentDeleted", this.updatePatientEntry);
            EventBus.$off("appointmentAdded", this.updatePatientEntryOrAdd);
            EventBus.$off("Relocated", this.updatePatientEntry);
        },
        watch: {
            patients(newVal, oldVal) {
                if (newVal) {
                    this.sortedAndFilteredPatients = this.applyFilters(newVal);
                } else {
                    this.sortedAndFilteredPatients = newVal;
                }
            },
            selectedStatuses(newVal, oldVal) {
                if (!newVal) {
                    return;
                }
                this.sortedAndFilteredPatients = this.applyFilters(this.patients);
                Vue.saveOngoingStatusFilters(newVal);
            },
            room(newVal, oldVal) {
                if (!newVal) {
                    this.primaryGroup = undefined;

                    return;
                }

                this.primaryGroup = newVal.group;
            },
            showOnlyPrimaryGroup() {
                this.filterPrimaryGroupAppointments();
            },
            primaryGroup() {
                console.log("Filtering primary group appointments on primary-group change");
                this.filterPrimaryGroupAppointments();
            }
        },
        methods: {
            filterPrimaryGroupAppointments() {
                this.sortedAndFilteredPatients = this.applyFilters(this.patients);
            },
            trim(comment) {
                if (comment && comment.length > 30) {
                    return comment.slice(0, 30) + "...";
                }

                return comment;
            },
            selectStatusFilter(status) {
                if (!this.selectedStatuses) {
                    this.selectedStatuses = [];
                }

                var index = this.selectedStatuses.indexOf(status);

                if (index > -1) {
                    this.selectedStatuses.splice(index, 1);
                } else {
                    this.selectedStatuses.push(status);
                }
            },
            applyFilters(patients) {
                return patients.filter(this.containsStatus);
            },
            containsStatus(patient) {
                if (!patient) {
                    return false;
                }

                if (this.primaryGroup && this.showOnlyPrimaryGroup === true) {
                    if (!patient.consultationGroup || patient.consultationGroup.id !== this.primaryGroup.id) {
                        return false;
                    }
                }

                if (!this.selectedStatuses) {
                    return true;
                }

                return this.selectedStatuses.includes(patient.status);
            },
            loggedIn(patient) {
                var res = Vue.getValueForKey(patient.patientProperties.entry, 'device');
                return res;
            },
            patientSelected(patient) {
                var device = this.loggedIn(patient) ? true : false;
                this.onSelectCallback({id: patient.patientId, name: patient.patientName, internalIds: patient.internalIds, status: patient.status, device: device});
            },
            updatePatientEntryOnPriority(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    app.setPatientEntry(patientId, res.data);
                    // Vue.scrollToElementWithId(patientId);
                });
            },
            updatePatientEntry(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Nothing fetched. Will remove this entry if exists.");
                        app.setPatientEntry(patientId, undefined);
                        return;
                    }
                    app.setPatientEntry(patientId, res.data);
                });
            },
            updatePatientEntryOrAdd(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Nothing fetched. Will remove this entry if exists.");
                        app.setPatientEntry(patientId, undefined);
                        return;
                    }

                    app.setPatientEntry(patientId, res.data);

                    if (!app.patientFound) {
                        app.patients.push(res.data);
                    }
                });
            },
            setPatientEntry(index, patient) {
                this.patientFound = false;
                for (var i = 0; i < this.patients.length; i++) {
                    if (this.patients[i] && this.patients[i].patientId === index) {
                        this.$set(this.patients, i, patient);
                        this.patientFound = true;
                        break;
                    }
                }
            },
            manuallyCallAppointment(patient) {
                var app = this;
                app.manualCallInProgress = true;

                if (this.physician && this.physician.status === "Paused") {
                    app.manualCallInProgress = false;
                    Vue.notifyError({title: app.$t("resumeConsultationsToCall")});
                } else {
                    frc.manuallyCallAppointment(Vue.prototype.$currentWard.id, this.room.id, patient.appointmentId).then(function (res) {
                        Vue.notifySuccess({title: app.$t("patientCalled")});
                        app.manualCallInProgress = false;
                        app.updatePatientEntry(patient.patientId);
                        EventBus.$emit("manuallyCalledPatient");
                    }).catch(function (ex) {
                        console.log(ex);
                        app.manualCallInProgress = false;
                    });
                }
            },
            flexiCallAppointment(patient) {
                var app = this;
                app.flexiCallInProgress = true;

                if (this.physician && this.physician.status === "Paused") {
                    app.flexiCallInProgress = false;
                    Vue.notifyError({title: app.$t("resumeConsultationsToCall")});
                } else {
                    frc.flexiCallAppointment(Vue.prototype.$currentWard.id, this.room.id, patient.appointmentId).then(function (res) {
                        Vue.notifySuccess({title: app.$t("patientCalled")});
                        app.flexiCallInProgress = false;
                        app.updatePatientEntry(patient.patientId);
                        EventBus.$emit("manuallyCalledPatient");
                    }).catch(function (ex) {
                        console.log(ex);
                        app.flexiCallInProgress = false;
                    });
                }
            }
        }

    }
</script>

<style scoped>
    .physician-patients-filter.active i.active-check {
        visibility: visible;
    }
    .physician-patients-filter i.active-check {
        visibility: hidden;
    }
    .physician-patients-filter {
        opacity: 0.4;
    }
    .physician-patients-filter.active {
        opacity: 1;
        border-color: #2ea878;
    }
    .physician-patients-filter.active div, .physician-patients-filter.active span {
        border: grey thin solid;
    }
    .physician-patients-filter .fa-check-circle {
        position: absolute;
        right: 8px;
    }
</style>